import { API_BASE } from '../config/api';
// ============================================
// HELPERSEXPEDIENTES.JS — Constantes y estilos del módulo
// ============================================

export const API_BASE_EXP = API_BASE;   // direccion del backend: config/api.js (fuente unica)
export const PP_EXP = "'Poppins', sans-serif";

export const COL_EXP = {
  principal: '#5c9adb',
  oscuro: '#2f5f9e',
  fondo: '#f3f4f4',
  gris: '#4e5357',
  grisClaro: '#8a8f95',
  borde: '#e6e8ea',
  blanco: '#fff',
};

export const ESTADOS_EXP = {
  creado:          { label: 'Creado',            color: '#94a3b8', bg: '#f1f5f9' },
  por_cotizar:     { label: 'Por cotizar',       color: '#a86b1e', bg: '#fff4e5' },
  cotizado:        { label: 'Cotizado',          color: '#2f5f9e', bg: '#eaf2fb' },
  por_programar:   { label: 'Por programar',     color: '#8b5cf6', bg: '#f3efff' },
  programado:      { label: 'Programado',        color: '#5c9adb', bg: '#eaf2fb' },
  en_ejecucion:    { label: 'En ejecución',      color: '#1D9E75', bg: '#e8faf5' },
  por_facturar:    { label: 'Por facturar',      color: '#f59e0b', bg: '#fff8ed' },
  facturado:       { label: 'Facturado',         color: '#6366f1', bg: '#eef0ff' },
  pagado:          { label: 'Pagado',            color: '#10b981', bg: '#e8faf5' },
  cancelado:       { label: 'Cancelado',         color: '#e05c5c', bg: '#fde8e8' },
  pausado:         { label: 'Pausado',           color: '#94a3b8', bg: '#f1f5f9' },
};

export const PRIORIDADES = {
  baja:    { label: 'Baja',    color: '#94a3b8' },
  normal:  { label: 'Normal',  color: '#5c9adb' },
  alta:    { label: 'Alta',    color: '#f59e0b' },
  urgente: { label: 'Urgente', color: '#e05c5c' },
};

export const TIPOS_EVENTO = [
  { id: 'levantamiento', label: 'Levantamiento' },
  { id: 'visita',        label: 'Visita' },
  { id: 'instalacion',   label: 'Instalación' },
  { id: 'entrega',       label: 'Entrega' },
  { id: 'mantenimiento', label: 'Mantenimiento' },
  { id: 'reunion',       label: 'Reunión' },
  { id: 'otro',          label: 'Otro' },
];

export const SEVERIDADES = {
  baja:    { label: 'Baja',    color: '#94a3b8' },
  media:   { label: 'Media',   color: '#f59e0b' },
  alta:    { label: 'Alta',    color: '#e05c5c' },
  critica: { label: 'Crítica', color: '#7c1d1d' },
};

export const estiloInputExp = {
  width: '100%', padding: '8px 10px', border: `1px solid ${COL_EXP.borde}`,
  borderRadius: 6, fontSize: 13, fontFamily: PP_EXP, outline: 'none',
  boxSizing: 'border-box', background: '#fff',
};

export const estiloBotonExp = {
  background: COL_EXP.principal, color: '#fff', border: 'none',
  padding: '8px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
  cursor: 'pointer', fontFamily: PP_EXP,
};

export const estiloBotonSecExp = {
  background: '#fff', color: COL_EXP.gris, border: `1px solid ${COL_EXP.borde}`,
  padding: '8px 14px', borderRadius: 8, fontSize: 12, fontWeight: 500,
  cursor: 'pointer', fontFamily: PP_EXP,
};

export const estiloTarjetaExp = {
  background: '#fff', border: `1px solid ${COL_EXP.borde}`, borderRadius: 10, padding: 14,
};

export function formatMoneda(n) {
  if (n == null) return '—';
  const num = Number(n);
  if (!Number.isFinite(num)) return '—';
  return '$' + num.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatFechaCorta(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' });
  } catch { return ''; }
}

export function formatFechaHora(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch { return ''; }
}
